/** Event */
export default {
  create: 'กำลังสร้าง',
  createProgramme: 'สร้างโปรแกรม AI',
  aiProgramme: 'โปรแกรม AI',
  name: 'ชื่อกิจกรรม',
  placeholder: 'ป้อนชื่อกิจกรรม',
  total: 'การลงทะเบียนทั้งหมด',
  likes: 'จำนวนไลค์ทั้งหมด',
  income: 'รายได้จากการลงทะเบียนทั้งหมด',
  tips: {
    total: 'จำนวนผู้สมัครไม่รวมการยกเลิก',
    income: 'รายได้ไม่รวมการคืนเงิน รางวัล และการขายสินค้า'
  },
  table: {
    name: 'ชื่อกิจกรรม',
    status: 'สถานะกิจกรรม',
    total: 'การลงทะเบียนทั้งหมด',
    today: 'การลงทะเบียนวันนี้',
    last_week: 'การลงทะเบียนสัปดาห์ที่แล้ว',
    create: 'เวลาที่สร้าง',
    update: 'เวลาที่อัปเดต',
    start: 'เวลาเริ่มต้น',
    end: 'เวลาสิ้นสุด',
    operate: 'การดำเนินการ',
    oper: {
      data: 'ข้อมูลการลงทะเบียน',
      config: 'การกำหนดค่าเนื้อหา',
      progress: 'การกำหนดค่าความคืบหน้า',
      display: 'การแสดงกิจกรรม',
      screen: 'หน้าจอข้อมูล',
      share: 'การแบ่งปันกิจกรรม',
      more: 'ฟังก์ชันเพิ่มเติม',
      mores: {
        setting: 'การตั้งค่าการแสดงผล',
        ad: 'การตั้งค่าโฆษณา',
        live: 'การถ่ายทอดสดด้วยรูปภาพ',
        video: 'ไฮไลท์วิดีโอ',
        qrcode: 'รหัส QR สำหรับลงชื่อเข้าใช้',
        gift: 'ของขวัญและรางวัล'
      }
    },
    total_number: 'รวม {total} รายการ'
  },
  create_form: {
    placeholder: 'กรุณาป้อน',
    status: {
      '是否确认立刻发布活动?': 'คุณแน่ใจหรือไม่ที่จะเผยแพร่กิจกรรมทันที?'
    },
    content: {
      title: 'เนื้อหากิจกรรม',
      name: {
        label: 'ชื่อกิจกรรม',
        hover: 'ชื่อของกิจกรรมนี้ เช่น: การแสดงภาพวาดของเด็กครั้งแรก'
      },
      cycle: {
        label: 'วงจรกิจกรรม',
        hover: 'ระยะเวลาทั้งหมดของกิจกรรม ตั้งแต่เริ่มต้นจนถึงสิ้นสุด: ตัวอย่าง: 2024.01.20 ~ 2024.05.20 หากยังไม่ได้ตัดสินใจ โปรดประมาณช่วงเวลา'
      },
      stage: {
        title: 'ขั้นตอนกิจกรรม',
        desc: 'ตอนนี้สามารถสร้างได้เพียงหนึ่งระยะเท่านั้น หากต้องการเพิ่มเติม ให้เสร็จสิ้นการตั้งค่าเริ่มต้น จากนั้นใช้ "การกำหนดค่าขั้นสูง" ในรายการกิจกรรม',
        name: {
          title: 'ชื่อระยะ',
          hover: 'ชื่อของขั้นตอนกิจกรรม ปัจจุบันสามารถกำหนดได้เพียงหนึ่งขั้นตอนเท่านั้น เช่น: รอบแรกหรือรอบที่สองหรือการออดิชั่นหรือรอบสุดท้าย'
        },
        start: {
          title: 'เวลาลงทะเบียน',
          hover: 'เวลาเริ่มต้นและสิ้นสุดการลงทะเบียนของขั้นตอนนี้ โปรดระบุให้ถูกต้องถึงนาทีและวินาที หมายเหตุ: ไม่อนุญาตให้ลงทะเบียนนอกช่วงเวลาลงทะเบียน หากยังไม่ได้ตัดสินใจ คุณสามารถกรอกข้อมูลได้ในภายหลัง'
        },
        hold: {
          title: 'เวลาจัดงาน',
          hover: 'เวลาเริ่มต้นและสิ้นสุดของขั้นตอนนี้ โปรดระบุให้ถูกต้องถึงนาทีและวินาที เช่น: ช่วงเวลาจัดนิทรรศการแบบออฟไลน์หรือช่วงเวลาพิธีมอบรางวัล หากยังไม่ได้ตัดสินใจ คุณสามารถกรอกข้อมูลได้ในภายหลัง'
        }
      },
      poster: {
        title: 'โปสเตอร์กิจกรรม',
        upload: 'คลิกเพื่ออัปโหลด',
        tips: {
          _1: 'เคล็ดลับ: รองรับรูปแบบรูปภาพ .jpg, .png ความจุภาพสูงสุดต้องไม่เกิน 5MB อัตราส่วนขนาดภาพควรเป็น 1:1 มากที่สุดเท่าที่จะเป็นไปได้ และขนาดขั้นต่ำคือ 860px*860px',
          _2: 'รูปภาพจะแสดงที่ด้านบนของหน้าผู้สมัคร คลิกเพื่อดูคำอธิบาย'
        }
      },
      detail: {
        desc: 'สามารถมองเห็นได้โดยผู้ลงทะเบียน คลิกเพื่อดูคำอธิบาย',
        placeholder: 'กรุณาป้อน',
        title: {
          _1: 'แนะนำกิจกรรม',
          _2: 'กฎการลงทะเบียน',
          _3: 'องค์กร'
        }
      }
    },
    group: {
      title: 'ข้อมูลกลุ่ม',
      desc: 'ปัจจุบัน สามารถสร้างกิจกรรมกลุ่มได้เพียงหนึ่งกลุ่มเท่านั้น มีกิจกรรมกลุ่มที่แตกต่างกันหลายกลุ่ม โปรดสร้างกิจกรรมเริ่มต้นให้เสร็จสิ้นก่อน จากนั้นคลิกที่ "การกำหนดค่ากิจกรรม - การกำหนดค่าการแข่งขันย่อย" ของกิจกรรมในรายการกิจกรรมเพื่อกำหนดค่า ระบบกิจกรรมสนับสนุนให้กิจกรรมกลุ่มที่แตกต่างกันสามารถตั้งค่าค่าธรรมเนียมการลงทะเบียน แบบฟอร์มการลงทะเบียน การเลือกพื้นฐาน แบบฟอร์มการลงทะเบียน และการตั้งค่าอื่นๆ ที่แตกต่างกัน',
      category: {
        title: 'กิจกรรม',
        hover: 'ตัวอย่าง: ศิลปะ; การเต้นรำ;',
        add: 'เพิ่มหมวดหมู่',
        name: 'ชื่อหมวดหมู่'
      },
      group: {
        title: 'กลุ่มกิจกรรม',
        hover: 'ตัวอย่าง: กลุ่มเยาวชน; กลุ่มผู้ใหญ่;',
        add: 'เพิ่มกลุ่ม',
        name: 'ชื่อกลุ่ม'
      },
      form: {
        title: 'แบบฟอร์มลงทะเบียน',
        hover: 'เนื้อหาข้อมูลที่ผู้ลงทะเบียนต้องกรอก หมวดหมู่หรือกลุ่มที่แตกต่างกันสามารถใช้แบบฟอร์มการลงทะเบียนที่แตกต่างกัน',
        create: 'สร้างข้อมูลการลงทะเบียนกิจกรรม'
      },
      charge: {
        title: 'ค่าธรรมเนียมการลงทะเบียน',
        hover: 'หมวดหมู่หรือกลุ่มที่แตกต่างกันสามารถกำหนดค่าธรรมเนียมที่แตกต่างกัน'
      },
      config: {
        title: 'การตั้งค่าการกำหนดค่าโดยละเอียด:',
        hover: 'หมวดหมู่หรือกลุ่มที่แตกต่างกันสามารถกำหนดกฎการคัดเลือก เกณฑ์การคัดเลือก วิธีการคัดเลือก จำนวนการคัดเลือก เวลาประกาศผลการคัดเลือก ฯลฯ ที่แตกต่างกัน',
        repeat: {
          title: 'การลงทะเบียนซ้ำสำหรับกลุ่มเดียวกัน:',
          hover: 'กิจกรรมกลุ่มอนุญาตให้ผู้ใช้ลงทะเบียนหลายครั้งด้วยข้อมูลเดียวกันหรือไม่',
          default: 'ปิด'
        },
        pass: {
          title: 'การตรวจสอบการลงทะเบียนผ่าน:',
          hover: 'หลังจากผู้ใช้ส่งการลงทะเบียน ระบบจะตรวจสอบโดยค่าเริ่มต้นหรือไม่เพื่อกำหนดว่าการลงทะเบียนถูกต้อง/ไม่ถูกต้อง',
          default: 'ผ่านโดยอัตโนมัติ',
          prepay: 'ตรวจสอบก่อน แล้วจึงชำระเงิน',
          postpay: 'ชำระเงินก่อน แล้วจึงตรวจสอบ'
        },
        show: {
          title: 'ศูนย์การลงทะเบียนแสดง:',
          hover: 'บุคคล: การลงทะเบียนเมื่อกรอกข้อมูลของคนเดียว "ทีม": การลงทะเบียนที่ประกอบด้วยข้อมูลของหลายคน แบ่งปันงาน',
          default: 'แสดง'
        },
        form: {
          title: 'แบบฟอร์มการลงทะเบียนกลุ่ม:',
          hover: 'บุคคล: การลงทะเบียนเมื่อกรอกข้อมูลของคนเดียว "ทีม": การลงทะเบียนที่ประกอบด้วยข้อมูลของหลายคน แบ่งปันงาน',
          default: 'บุคคล',
          team: 'ทีม',
          min: 'ขนาดทีมขั้นต่ำ:',
          max: 'ขนาดทีมสูงสุด:'
        },
        base: {
          title: 'ฟังก์ชันการประเมินพื้นฐาน:',
          hover: 'เปิดใช้งานฟังก์ชันการประเมินพื้นฐานหรือไม่ ตัวอย่าง: เปิดใช้งานหรือปิด',
          default: 'ปิด'
        },
        commission: {
          title: 'ค่าคอมมิชชันพาร์ทเนอร์:',
          hover: 'ในฐานะช่องทางย่อยของผู้จัดงาน พาร์ทเนอร์กำหนดอัตราส่วนค่าคอมมิชชันของค่าธรรมเนียมการลงทะเบียน',
          default: 'ปิด'
        },
        inherit: {
          title: 'การสืบทอดหมายเลขการคัดเลือก:',
          hover: 'ในการจัดการการคัดเลือกขั้นสูงในเมนูหลัก คุณสามารถตั้งค่าหมายเลขการคัดเลือกของผลงานที่ลงทะเบียน และหมายเลขสามารถสืบทอดไปยังรอบถัดไปเมื่อก้าวหน้า',
          default: 'ปิด'
        }
      }
    },
    session: {
      title: 'ข้อมูลเซสชัน',
      desc: 'เคล็ดลับ: การสร้างเซสชันปัจจุบันเกี่ยวข้องกับกิจกรรมกลุ่มที่สร้างในขั้นตอนก่อนหน้าเท่านั้น กิจกรรมกลุ่มหลายรายการมีการจัดเรียงเซสชัน โปรดสร้างกิจกรรมเริ่มต้นให้เสร็จสิ้นก่อน เข้าสู่การจัดการกิจกรรม และคลิก "การกำหนดค่ากิจกรรม - การกำหนดค่าการแข่งขันย่อย - การกำหนดค่าเซสชัน" เพื่อกำหนดค่า กลุ่มเดียวสามารถสร้างเซสชันหลายรายการ และกลุ่มต่างๆ ยังสามารถสร้างเซสชันที่แตกต่างกัน',
      name: 'กิจกรรมกลุ่ม',
      number: {
        title: 'ผู้ลงทะเบียน',
        hover: 'ผู้ลงทะเบียนถูกกำหนดไว้สำหรับเซสชันเดียว หากมีหลายเซสชัน จำนวนผู้เข้าร่วมสำหรับแต่ละเซสชันจะต้องกำหนดแยกกัน',
        config: 'การตั้งค่า',
        default: 'ไม่จำกัด'
      },
      arrange: {
        title: 'การจัดการเซสชัน',
        hover: 'หากยังไม่ได้กำหนดการจัดการเซสชันที่เกี่ยวข้อง คุณสามารถปิดได้ หากมีการจัดการเซสชันอยู่แล้ว คุณสามารถเปิดเพื่อตั้งค่า รองรับทั้งออนไลน์และออฟไลน์',
        default: 'ปิด'
      },
      form: 'รูปแบบเซสชัน:',
      online: 'ที่อยู่ออนไลน์',
      offline: 'การเลือกภูมิภาค',
      address: 'ที่อยู่โดยละเอียด',
      time: 'เวลาเซสชัน'
    }
  }
} 



// WEBPACK FOOTER //
// ./src/langs/th/activity.js